import { Injectable } from '@angular/core';
import { ApiServiceBase } from '@api/abstracts';
import { Appointment } from '@components/form/components/form-layout-1/model';

@Injectable({ providedIn: 'root' })
export class AppointmentService extends ApiServiceBase<Appointment> {
  constructor() {
    super('rdvs', 'appointment', 'fournierWebservice');
  }
}
